import { browser } from '$app/environment'
import { tenantId } from '$lib/domain/tenantSettings/tenantId'
import { environmentDomain } from '@helpers/settings'
import { get } from 'svelte/store'

const originalFetch = browser ? window.fetch : fetch

function isOurApiCall(resource: RequestInfo | URL) {
	return (
		typeof resource === 'string' &&
		resource.startsWith(`https://${get(tenantId)}.${environmentDomain}`)
	)
}

export function setRequestInterceptor(accountId: string | null) {
	window.fetch = async (...args) => {
		const [resource, config] = args

		// request interceptor starts
		if (isOurApiCall(resource) && accountId) {
			config.headers = {
				...config.headers,
				'X-Impersonated-Account-Id': accountId,
			}
		}
		// request interceptor ends

		const response = await originalFetch(resource, config)

		return response
	}
}
